import React from 'react';
import * as DefaultIcons from './Icons';

const hasDefaultImage = (wishImage) => wishImage && wishImage.includes('grid');

const GoalCustomImage = ({ imageURL, color }) => {
  let content;

  if (imageURL) {
    content = (
      <span
        className="photo"
        style={{
          backgroundImage: `url(${imageURL})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
      />
    );
  }

  return (
    <>
      <div className={`graph-mask dashboard-goal-photo ${color} with-photo`}>
        {content}
      </div>
      <div>
        <div className="slice slice-mask">
          <div className="slice-content" />
        </div>
        <div className="slice slice-fill">
          <div className={`slice-content ${color}`} />
        </div>
      </div>
    </>
  );
};

export default function Avatar({ goal, aloneView, color }) {
  let content;

  color = color || 'steelblue';

  switch (goal.type) {
    case 1:
      content = <DefaultIcons.SavingsGoal aloneView={aloneView} />;
      break;
    case 2:
      content = hasDefaultImage(goal.wishImage)
        ? <DefaultIcons.EducationGoal aloneView={aloneView} />
        : <GoalCustomImage imageURL={goal.wishImage} color="blue" />;
      break;
    case 3:
      content = hasDefaultImage(goal.wishImage)
        ? <DefaultIcons.FunGoal aloneView={aloneView} />
        : <GoalCustomImage imageURL={goal.wishImage} color="darkblue" />;
      break;
    case 5:
      content = hasDefaultImage(goal.wishImage)
        ? <DefaultIcons.EmergencyGoal aloneView={aloneView} color={color} />
        : <GoalCustomImage imageURL={goal.wishImage} color={color} />;
      break;
    case 6:
      content = hasDefaultImage(goal.wishImage)
        ? <DefaultIcons.RainyGoal aloneView={aloneView} color={color} />
        : <GoalCustomImage imageURL={goal.wishImage} color={color} />;
      break;
    case 10:
        content = hasDefaultImage(goal.wishImage)
          ? <DefaultIcons.PayOffDebtGoal aloneView={aloneView} color={color} />
          : <GoalCustomImage imageURL={goal.wishImage} color={color} />;
        break;
    default:
      content = hasDefaultImage(goal.wishImage)
        ? <GoalCustomImage imageURL={goal.wishImage} color={color} />
        : <DefaultIcons.CustomGoal aloneView={aloneView} color={color} />;
      break;
  }

  return (
    <div className={`graph dashboard-card-goal-diagram ${aloneView ? 'alone-view' : ''}`}>
      {content}
    </div>
  );
}
